<template>
    <form method="post" autocomplete="off" @submit.prevent="submitSettings">
        <h1>{{ $t('labels.settings') }}</h1>

        <div class="row">
            <div class="col">
                <label class="switch mr-3">
                    <input type="checkbox" :checked="pinVisible" @click="$store.dispatch('togglePinVisible')">
                    <span class="slider round"></span>
                </label>

                <span class="pt-2" v-text="$t('labels.pin_visible')"></span>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <label class="switch mr-3">
                    <input type="checkbox" :checked="darkMode" @click="$store.dispatch('toggleDarkMode')">
                    <span class="slider round"></span>
                </label>

                <span class="pt-2" v-text="$t('labels.dark_mode')"></span>
            </div>
        </div>

      <div class="row">
        <div class="col">
          <h1>{{ $t('labels.select_location') }}</h1>
          <div class="form-group">
            <label for="location" class="sr-only">{{ $t('labels.location') }}</label>
            <select name="location" id="location" class="form-control" v-model="selectedLocation">
              <option value="">{{ $t('labels.select_location') }}</option>
              <option v-for="location in locations" :key="location.id.toString()" :value="location.id">{{ location.name }}</option>
            </select>
          </div>
          <hr>
        </div>
      </div>

        <div class="app-actions">
            <div class="col-sm-6 text-right">
              <div class="text-right">
                <button class="btn btn-lg btn-danger mr-3" type="button" @click="close">{{ $t('labels.close') }}</button>
                <button class="btn btn-lg btn-primary mr-3" type="submit" :disabled="submitDisabled">{{ $t('labels.save') }}</button>
              </div>
            </div>
        </div>
    </form>
</template>

<script>

    import axios from "axios"
    import {isOnline} from "@/utils/online";
    import * as config from "@/config/config";
    import {syncAndUpdate} from "@/utils/sync";

    export default {
        name: 'settings',

        data () {
            return {
                visible: [],
                hidden: [],
                editable: true,
                selectedLocation: '',
                submitDisabled: false,
            };
        },

		computed: {
			currentDevice () {
				return this.$store.state.currentDevice;
			},

      locations() {
        return this.$store.state.locations;
      },

      currentLocation () {
        return this.$store.state.currentLocation;
      },

      currentEmployee () {
        return this.$store.state.currentEmployee;
      },

      pinVisible () {
        return this.$store.state.pinVisible;
      },

      darkMode () {
        return this.$store.state.darkMode;
      },

		},

    watch: {
      locations(val) {
        if (val && val.length) this.selectedLocation = this.locations[0].id;
      },

    },

      methods: {

        close () {
          let navbar = this.$parent.$children.find(item => item.$options.name === 'navbar');

          if (!navbar) return this.$router.go(-1);

          return window.setTimeout(() => this.$router.go(-1), 300);
        },


        submitSettings() {

          if (this.selectedLocation !== this.currentLocation.id) {

            let location = this.$store.getters.locationById(this.selectedLocation);
            this.$store.dispatch('setCurrentLocation', location);


            // First sync all updates
            syncAndUpdate(this)
                .then(() => {
                  // Then update device settings
                  axios.put(
                      config.api.current + '/device/settings',
                      {location_id: location.id},
                      {headers: {'Authorization': 'Bearer ' + this.$store.state.token}}
                  ).then(() => {
                    // Then resync resources
                    this.$store.dispatch('syncResources', self)
                        .then(res => {
                          this.close();
                        });
                  });
            })


          } else {
            this.close();
          }

        },
      },

		mounted () {
			window.events.$emit('disableNumpad');

			if(this.currentEmployee === null || this.currentEmployee === undefined) return this.$router.push({name: 'pin'});

			let main = document.querySelector('.app-main');
			let sidebar = document.querySelector('.app-sidebar');

			main.classList.add('app-main--fullscreen');
			sidebar.style.display = 'none';

			window.events.$emit('setFullscreen', true);

      if (this.currentLocation) {
        this.selectedLocation = this.currentLocation.id;
      }
		},

		beforeDestroy () {
			window.events.$emit('setFullscreen', false);

			let main = document.querySelector('.app-main');
			let sidebar = document.querySelector('.app-sidebar');

			main.classList.remove('app-main--fullscreen');
			sidebar.style.display = 'flex';
		}
  }
</script>

